
import * as ipxRuntime$b8DSNUANEofH8KYR1JdeF5_45xvu_DKRk_1Ba7RxKsAkQ from '/app/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$b8DSNUANEofH8KYR1JdeF5_45xvu_DKRk_1Ba7RxKsAkQ, defaults: {} }
}
        